import apiClient from "../../services/api";

export function register({ group_id, name, email, password }) {
  return apiClient.post(`/auth/register/${group_id}`, { name: name, email: email, password: password });
}
